import { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Paper,
  Box,
  MenuItem,
  Typography,
} from "@mui/material";
import Translate from "../../../../modules/Core/Components/Translate";

import { format, addDays } from "date-fns";
import { el, enUS } from "date-fns/locale";

export default function ContactUs(props) {
  const { component } = props;
  const { store = null, dates = [] } = component.props;
  const devHelper = component.getHelpers("dev");
  const stores = component.getData("default.stores", []);

  const [showStores, setShowStores] = useState(true);
  const [availableDates, setAvailableDates] = useState([]);

  // Δημιουργία ωρών ανά 1 ώρα
  const generateTimeSlots = () => {
    const slots = [];
    for (let hour = 10; hour < 20; hour++) {
      slots.push(
        `${hour.toString().padStart(2, "0")}:00 - ${(hour + 1)
          .toString()
          .padStart(2, "0")}:00`
      );
    }
    return slots;
  };

  const availableTimes = generateTimeSlots();

  useEffect(() => {
    if (store && stores.length > 0) {
      component.setData({
        "default.fields.store": store,
      });
      setShowStores(false);
    }
  }, [store, stores, component]);

  useEffect(() => {
    const locale = component.trans("lang") === "el" ? el : enUS;
    const result = [];
    if (dates.length > 0) {
      dates.forEach((date) =>
        result.push({
          value: format(new Date(date), "yyyy-MM-dd"),
          label: format(new Date(date), "EEEE d MMM", { locale }),
        })
      );
    } else {
      let dayCount = 1; // Ξεκινάμε από αύριο
      let currentDate = addDays(new Date(), dayCount);

      while (result.length < 7) {
        const dayOfWeek = currentDate.getDay(); // 0 = Κυριακή

        if (dayOfWeek !== 0) {
          result.push({
            value: format(currentDate, "yyyy-MM-dd"),
            label: format(currentDate, "EEEE d MMM", { locale }),
          });
        }

        dayCount += 1;
        currentDate = addDays(new Date(), dayCount);
      }
    }
    setAvailableDates(result);
  }, [dates, component]);

  return (
    <Box sx={{ maxWidth: 500, margin: "auto", mb: 5, p: 2 }}>
      <Paper sx={{ py: 1, px: 2 }}>
        <form onSubmit={(e) => component.sendRequest(e)}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label={component.ucfirst("fullname-textfield")}
            name="name"
            autoComplete="name"
            helperText={component.getData("error.fields.name")}
            value={component.getData("default.fields.name", "")}
            onChange={(e) => {
              component.setData({
                "default.fields.name": e.target.value,
              });
              component.deleteData("error.fields.name");
            }}
            error={component.dataExists("error.fields.name")}
          />
          {/* <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label={component.ucfirst("email-textfield")}
            name="email"
            helperText={component.getData("error.fields.email")}
            value={component.getData("default.fields.email", "")}
            onChange={(e) => {
              component.setData({
                "default.fields.email": e.target.value,
              });
              component.deleteData("error.fields.email");
            }}
            error={component.dataExists("error.fields.email")}
          /> */}
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label={`${component.ucfirst("phone-textfield")}`}
            name="phone"
            helperText={component.getData("error.fields.phone")}
            value={component.getData("default.fields.phone", "")}
            onChange={(e) => {
              component.setData({
                "default.fields.phone": e.target.value,
              });
              component.deleteData("error.fields.phone");
            }}
            error={component.dataExists("error.fields.phone")}
          />
          <TextField
            select
            variant="outlined"
            margin="normal"
            fullWidth
            label={`${component.ucfirst("date-textfield")}`}
            name="date"
            helperText={component.getData("error.fields.date")}
            value={component.getData("default.fields.date", "")}
            onChange={(e) => {
              component.setData({
                "default.fields.date": e.target.value,
              });
              component.deleteData("error.fields.date");
            }}
            error={component.dataExists("error.fields.date")}
          >
            {availableDates.map((d) => (
              <MenuItem key={d.value} value={d.value}>
                {d.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            variant="outlined"
            margin="normal"
            fullWidth
            label={`${component.ucfirst("time-textfield")}`}
            name="time"
            helperText={component.getData("error.fields.time")}
            value={component.getData("default.fields.time", "")}
            onChange={(e) => {
              component.setData({
                "default.fields.time": e.target.value,
              });
              component.deleteData("error.fields.time");
            }}
            error={component.dataExists("error.fields.time")}
          >
            {availableTimes.map((time) => (
              <MenuItem key={time} value={time}>
                {time}
              </MenuItem>
            ))}
          </TextField>
          {showStores && (
            <TextField
              select
              variant="outlined"
              margin="normal"
              fullWidth
              label={`${component.ucfirst("store-textfield")}`}
              name="store"
              helperText={component.getData("error.fields.store")}
              value={component.getData("default.fields.store", "")}
              onChange={(e) => {
                component.setData({
                  "default.fields.store": e.target.value,
                });
                component.deleteData("error.fields.store");
              }}
              error={component.dataExists("error.fields.store")}
            >
              {stores.map((store) => {
                const slug = devHelper.getObjectValue(store, "slug");
                return (
                  <MenuItem value={slug} key={slug}>
                    <Translate
                      entity="item"
                      eslug={slug}
                      scope="default"
                      slug="name"
                      auto
                    />
                  </MenuItem>
                );
              })}
            </TextField>
          )}
          <Button
            type="submit"
            fullWidth
            sx={{
              mt: 2,
              mb: 1,
              padding: "12px 14px",
              background: "#000",
              color: "#fff",
              "&:hover": {
                background: "#000",
              },
            }}
          >
            {component.ucfirst("appointment-button")}
          </Button>
        </form>
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="caption">
            Τα ραντεβού επιβεβαιώνονται βάσει σειράς προτεραιότητας.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}
